/**
 * Property slugs become public website urls (`/property/<slug>`), so only
 * letters, digits and hyphens may be stored. Spaces turn into hyphens, and
 * percent-encoded text pasted from an address bar is decoded first, so
 * "Nusa%20Dua" becomes "Nusa-Dua" instead of "Nusa20Dua". Case, repeated
 * hyphens and trailing hyphens are left alone because existing urls use them.
 */
export function toUrlSafeSlug(input: string): string {
  let text = input;
  try {
    text = decodeURIComponent(input);
  } catch {
    // a lone "%" is not a valid escape; the strip below removes it
  }
  return text.replace(/\s+/g, "-").replace(/[^A-Za-z0-9-]/g, "");
}

/** server-side guard for mutations that store a property slug */
export function requireUrlSafeSlug(input: string): string {
  const slug = toUrlSafeSlug(input.trim());
  if (!/[A-Za-z0-9]/.test(slug)) {
    throw new Error("Slug must contain letters or numbers");
  }
  return slug;
}
